import { Link, useLocation } from "react-router-dom";
import styles from "./Navbar.module.css";
import { TradeLyftLockup } from "../Brand";
import GlobalIcon from "../GlobalIcon/GlobalIcon";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import Avatar from "../Avatar/Avatar";
import ThemeToggle from "../ThemeToggle/ThemeToggle";
import IstClock from "./IstClock";

function Navbar() {
  const location = useLocation();
  const isFundsActive = location.pathname === "/funds";

  return (
    <div className={styles["navbar"]}>
      <div className={styles["navbar-brand"]}>
        <TradeLyftLockup size={36} className={styles["navbar-lockup"]} />
      </div>
      <Breadcrumb />
      <div className={styles["navbar-actions"]}>
        <IstClock />
        <Link
          to="/funds"
          className={`${styles["navbar-action-button"]} ${isFundsActive ? styles["navbar-action-button-active"] : ""}`}
          aria-label="Funds"
        >
          <GlobalIcon
            iconName="FundsIcon"
            className={styles["action-button-icon"]}
          />
          <span className={styles["action-button-text"]}>Funds</span>
        </Link>
        <ThemeToggle />
        <Avatar />
      </div>
    </div>
  );
}

export default Navbar;
